/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import { PatientPatient, PatientPatientFromJSON, PatientPatientFromJSONTyped, PatientPatientToJSON } from "./";

export const GetLinkedPatientResponseTypename = "GetLinkedPatientResponse" as const;

/**
 *
 * @export
 * @interface GetLinkedPatientResponse
 */
export interface GetLinkedPatientResponse {
  /**
   *
   * @type {string}
   * @memberof GetLinkedPatientResponse
   */
  customToken?: string;
  /**
   *
   * @type {PatientPatient}
   * @memberof GetLinkedPatientResponse
   */
  patient?: PatientPatient;
  /**
   * Resource type name
   * @type {string}
   * @memberof GetLinkedPatientResponse
   */
  readonly __typename?: string;
}

export function GetLinkedPatientResponseFromJSON(json: any): GetLinkedPatientResponse {
  return GetLinkedPatientResponseFromJSONTyped(json, false);
}

export function GetLinkedPatientResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetLinkedPatientResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: GetLinkedPatientResponseTypename,

    customToken: !exists(json, "custom_token") ? undefined : json["custom_token"],
    patient: !exists(json, "patient") ? undefined : PatientPatientFromJSON(json["patient"]),
  };
}

export function GetLinkedPatientResponseToJSON(object?: GetLinkedPatientResponse | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    custom_token: value.customToken,
    patient: PatientPatientToJSON(value.patient),
  };
}
